/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
// I want to keep this empty glimmer class to keep the Arguments type as documentation
import type FormyComponent from "../index";

interface Signature {
  Args: {
    /**
     * The text of the submit button.
     * If missing, it will default to: "ENREGISTRER"
     * */
    submitText?: string;
    formy: FormyComponent;
  };
}

import Component from "@glimmer/component";

import styles from "./index.module.css";
class FormyActionsComponent extends Component<Signature> {
  styles = styles;
}
export default FormyActionsComponent;
